import {IFieldValidator} from "../field-validator.interface";
import {NullableString} from "../../../types/nullable-types";

export class PersonNameValidator implements IFieldValidator {
    constructor(private readonly errorMessage: string) {
    }

    static regularExpression = /^[ a-zA-Z'-]*$/

    validate(fieldValue: any): NullableString {
        if(!fieldValue) {
            return null;
        }

        if(PersonNameValidator.regularExpression.test(fieldValue)) {
            return null;
        }

        return this.errorMessage;
    }
}
